import { __exportAll } from "./_virtual/_rolldown/runtime.js";
import "./kiosk_availability.js";
//#region src/kiosk_availability_helper.ts
var kiosk_availability_helper_exports = /* @__PURE__ */ __exportAll({ name: () => name });
function name(availability) {
	switch (availability) {
		case 2: return "Off Indefinitely";
		case 1: return "Off Until Next Service";
		case 0: return "On";
	}
}
//#endregion
export { kiosk_availability_helper_exports, name };

//# sourceMappingURL=kiosk_availability_helper.js.map